import { useState } from 'react';
import { PageTabs } from '@partiu/ui/components/organisms/PageTabs.tsx';
import { DashboardTemplate } from '../../components/templates/DashboardTemplate.tsx';
import { CPFFilterTab } from './tabs/CPFFilterTab.tsx';
import { BooksDataTableTab } from './tabs/BooksDataTableTab.tsx';
import { BooksGroupedTab } from './tabs/BooksGroupedTab.tsx';
import { SendConfigurationTab } from './tabs/SendConfigurationTab.tsx';

export default function BooksReportTabsPage() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <DashboardTemplate>
      <PageTabs
        index={activeTab}
        onChange={setActiveTab}
        tabs={[
          { label: '📈 Títulos por Mês', content: <BooksGroupedTab /> },
          { label: '🔍 Filtro por CPF', content: <CPFFilterTab /> },
          { label: '📊 Tabela de Logs', content: <BooksDataTableTab /> },
          { label: '⚙️ Configuração de Envio', content: <SendConfigurationTab /> },
        ]}
      />
    </DashboardTemplate>
  );
}
